__turbopack_context__.v({
  "label": "radio-module__hOfVSW__label",
});
